export function convertNextPage(nextPage: string): string {
	// Iben: Early exit if there is no nextPage
	if (!nextPage) {
		return '';
	}

	// Iben: get the index of the nextPage
	return new URL(nextPage).searchParams.get('index') || '';
}
